import { Paperclip } from "react-feather";
import axios from "axios";
import { useEffect, useState } from "react";
import { useMessage } from "../../../../global-components/src";
import { useAuth } from "../../../../global-components/src";
import { PACOCA_API_URL } from "../../../../global-components/src/utils/vars";
import { useTranslation } from "react-i18next";
import { DropdownItem } from "../../../AnchoredDropdown/AnchoredDropdown";

interface PinCommentProps {
    commentId: number;
    postOwnerId: number;
    isPinned: boolean;
    onToggle: (commentId: number, pinned: boolean) => void;
}

const PinComment: React.FC<PinCommentProps> = ({ commentId, postOwnerId, isPinned, onToggle }) => {
    const [pinned, setPinned] = useState(isPinned);
    const [loading, setLoading] = useState(false);
    const { setMessage } = useMessage();
    const { user, token } = useAuth();
    const { t } = useTranslation();

    useEffect(() => {
        setPinned(isPinned);
    }, [isPinned]);

    // if (!user || user.id !== postOwnerId) return null;

    const handleToggle = async () => {
        if (loading) return;
        setLoading(true);
        const action = pinned ? "unpin" : "pin";
        try {
            await axios.post(
                `${PACOCA_API_URL}/posts/comments/${action}/${commentId}`,
                {},
                { headers: { Authorization: `Bearer ${token}`, Accept: "application/json" } }
            );
            const next = !pinned;
            setPinned(next);
            onToggle(commentId, next);
            setMessage(next ? t("post.commentPinned") : t("post.commentUnpinned"), "success");
        } catch (err: any) {
            const msg = err?.response?.data?.message || t("generics.error");
            setMessage(msg, "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <DropdownItem icon={<Paperclip size={15} className="icon-config-post" />} onClick={handleToggle}>
            {pinned ? t("post.unpinComment") : t("post.pinComment")}
        </DropdownItem>
    );
};

export default PinComment;
